<template>
  <div class="perCenter">
    <navtab class="navTab"></navtab>
    <div class="bigPar">
      <div class="lef">
        <div class="lefTop">
          <div class="perHead">
            <img :src="user.headUrl?user.headUrl:imgUrl" alt />
          </div>
          <p class="perName" v-text="user.nickName?user.nickName:''">{{user.nickName}}</p>
          <p class="perPhone">手机号:{{user.userName}}</p>
          <div class="updateBtn" @click="updatePerInfo()">修改信息</div>
          <div class="updateBtn" id="out" @click="outLogin()">退出登录</div>
        </div>
        <ul class="lefBottom">
          <li @click="showMyorder()" :class="liFlag==1?'actColor':''">
            <p class="el-icon-tickets aaa"></p>
            <p class="bbb">我的订单</p>
          </li>
          <li @click="showMysave()" :class="liFlag==2?'actColor':''">
            <p class="el-icon-star-off aaa"></p>
            <p class="bbb">我的收藏</p>
          </li>
          <li @click="showMyaddress()" :class="liFlag==3?'actColor':''">
            <p class="el-icon-location-outline aaa"></p>
            <p class="bbb">我的地址</p>
          </li>
          <li @click="showProBlem()" :class="liFlag==4?'actColor':''">
            <p class="el-icon-search aaa"></p>
            <!-- <p class="el-icon-question aaa"></p> -->
            <p class="bbb">常见问题</p>
          </li>
          <li @click="showAdvice()" :class="liFlag==5?'actColor':''">
            <p class="el-icon-sold-out aaa"></p>
            <p class="bbb">意见反馈</p>
          </li>
          <li id="nouse">
            <p class="aaa"></p>
            <p class="bbb"></p>
          </li>
        </ul>
      </div>
      <div class="rig">
        <!-- 标签页 -->
        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick" v-if="showModel==1">
          <el-tab-pane
            v-for="(item,index) in orderList"
            :key="item"
            :value="index"
            :label="item.title"
            :name="'order-'+index"
          >
            <div style="margin-top: 15px;">
              <el-input placeholder="请输入物品名称进行搜索" v-model="input5" class="input-with-select">
                <el-button slot="append" icon="el-icon-search">搜索</el-button>
              </el-input>
              <div class="morePart">
                <div class="checkboxDiv">
                  <input
                    type="checkbox"
                    :checked="item.chooseAll"
                    @click="chooseOrderOne(index,-1)"
                    name
                    id
                  />
                  <p class="checkboxP">全选</p>
                </div>
                <div
                  class="mostYes"
                  v-if="activeName2.split('-')[1]==2"
                  @click="confirmAll(index)"
                >批量确认收货</div>
                <div
                  class="mostDele"
                  v-if="activeName2.split('-')[1]==1"
                  @click="deleteAll(index)"
                >批量删除</div>
              </div>
              <ul class="tabList">
                <li class="pro">宝贝</li>
                <li class="onePrice">单价</li>
                <li class="num">数量</li>
                <li class="realPrice">实付款</li>
                <li class="status">状态</li>
                <li class="operateTab">操作</li>
              </ul>
              <div class="noDataDiv" v-show="queryOrderKey(item.list).length==0">
                <img src="../assets/noData.png" alt />
              </div>
              <p class="noDataP" v-show="queryOrderKey(item.list).length==0">暂无对应订单信息</p>
              <div
                class="orderList"
                v-for="(todo,num) in queryOrderKey(item.list)"
                :key="todo.id"
                :value="num"
              >
                <div class="proOperateTab">
                  <input
                    type="checkbox"
                    :checked="todo.choose"
                    name
                    id
                    @click="chooseOrderOne(index,num)"
                  />
                  <p class="time">{{todo.modifytime.substr(0,10)}}</p>
                  <p class="proSortNum">订单编号：{{todo.id}}</p>
                  <p
                    class="el-icon-delete deleteBtn"
                    v-if="todo.type==1"
                    @click="deleteOrder(index,num)"
                  ></p>
                </div>
                <div class="proPart">
                  <div class="proPartLef">
                    <ul class="proPartLefUl">
                      <li class="goodsImg">
                        <img :src="todo.goodsEntity.imgurl.split(',')[0]" alt />
                      </li>
                      <li class="goodsName">{{todo.goodsEntity.name}}</li>
                      <li class="goodsPrice">￥{{todo.price}}</li>
                      <li class="goodsNum">{{todo.size}}</li>
                    </ul>
                  </div>
                  <div class="totalPrice">￥{{todo.money}}</div>
                  <div
                    class="goodsStatus"
                  >{{todo.type==1?'待支付':(todo.type==2?"待收货":(todo.type==3?"待评价":(todo.type==5?"已评价":"退货")))}}</div>
                  <div class="goodsOperate">
                    <p v-if="todo.type==1" @click="goPay(index,num)">去支付</p>
                    <p v-if="todo.type==2" @click="confirmOrder(index,num)">确认收货</p>
                    <p v-if="todo.type==2 || todo.type==3 || todo.type==5" @click="seeWuliu(index,num)">查看物流</p>
                    <p v-if="todo.type==3" @click="reviewOrder(index,num)">评价</p>
                    <!-- <p class="complain">投诉</p> -->
                    <p
                      class="backGoods"
                      v-if="todo.type>=2&&todo.type<=3"
                      @click="refundOrder(index,num)"
                    >退货</p>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!-- v-show="isMySave" -->
        <div class="mySave" v-if="showModel==2">
          <el-tabs v-model="activeName3" @tab-click="handleClick">
            <el-tab-pane
              v-for="(item,index) in collectList"
              :key="index.id"
              :value="index"
              :label="item.name"
              :name="'collect-'+index"
            >
              <div class="noDataDiv" v-show="endNewsList.length==0">
                <img src="../assets/noData.png" alt />
              </div>
              <p class="noDataP" v-show="endNewsList.length==0">暂无数据</p>
              <ul class="storeUl">
                <li
                  class="storeLi"
                  v-for="(todo,num) in endNewsList"
                  :key="num"
                  :num="num"
                  @click="toDetail(index,todo.id)"
                >
                  <div class="storeImg" v-if="todo.img!=''&&todo.img!=null">
                    <img :src="todo.img.split(',')[0]" alt />
                  </div>
                  <p class="storeName" v-text="todo.title">常开式电磁阀</p>
                </li>
                <!-- <li
                  id="noUseLi"
                  class="storeLi"
                >
                  <div class="storeImg" v-if="todo.img!=''&&todo.img!=null">
                    <img :src="endNewsList[0].img.split(',')[0]" alt />
                  </div>
                  <p class="storeName" v-text="endNewsList[0].title">常开式电磁阀</p>
                </li>
                <li
                  id="noUseLi"
                  class="storeLi"
                >
                  <div class="storeImg" v-if="todo.img!=''&&todo.img!=null">
                    <img :src="endNewsList[1].img.split(',')[1]" alt />
                  </div>
                  <p class="storeName" v-text="endNewsList[1].title">常开式电磁阀</p>
                </li>
                <li
                  id="noUseLi"
                  class="storeLi"
                >
                  <div class="storeImg" v-if="todo.img!=''&&todo.img!=null">
                    <img :src="endNewsList[2].img.split(',')[2]" alt />
                  </div>
                  <p class="storeName" v-text="endNewsList[2].title">常开式电磁阀</p>
                </li>
                <li
                  id="noUseLi"
                  class="storeLi"
                >
                  <div class="storeImg" v-if="todo.img!=''&&todo.img!=null">
                    <img :src="endNewsList[3].img.split(',')[3]" alt />
                  </div>
                  <p class="storeName" v-text="endNewsList[3].title">常开式电磁阀</p>
                </li>-->
                <!-- <li
                  id="noUseLi"
                  class="storeLi"
                >
                  <div class="storeImg" v-if="todo.img!=''&&todo.img!=null">
                    <img src="../assets/1.png" alt />
                  </div>
                  <p class="storeName">常开式电磁阀</p>
                </li>-->
              </ul>
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="20"
                :current-page="currentPage"
                @current-change="changePage"
                :total="total"
              ></el-pagination>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- v-show="isMyAddress" -->
        <div class="myAddress" v-if="showModel==3">
          <p class="myAddressTitle">我的地址</p>
          <p class="addBtn el-icon-plus" @click="addAddress()">添加收货地址</p>
          <div class="noDataDiv" v-show="addressList.length==0">
            <img src="../assets/noData.png" alt />
          </div>
          <p class="noDataP" v-show="addressList.length==0">小主您还没有添加收货地址哦！</p>
          <ul class="addressUl">
            <!-- <li class="addressLi" v-for="(item,index) in addressList" :key="index" :value="index"> -->
            <li
              class="addressLi"
              title="点击设置为默认地址"
              v-for="(item,index) in addressList"
              :key="index"
              :value="index"
              @click="setDefault(index)"
            >
              <div class="head">
                <img src="../assets/head.jpg" alt />
              </div>
              <div class="default">
                <img src="../assets/default.png" alt v-if="item.type==1" />
              </div>
              <ul class="addressPerUl">
                <li class="addressPerUlName">{{item.name}}</li>
                <li
                  class="addressPerUlAddress"
                  :title="item.address+item.detailed"
                >地址：{{item.address+item.detailed}}</li>
                <li class="addressPerUlPhone">手机号：+{{item.phone}}</li>
                <li class="addressPerUlEmail">邮编：{{item.postal}}</li>
              </ul>
              <div class="operateDiv">
                <p class="editBtn" @click.stop="editAddress(index)">编辑</p>
                <!-- <p class="editBtn" v-if="item.type!=1" @click="setDefault(index)">设为默认</p> -->
                <!-- <p class="editBtn" v-if="item.type!=1">设为默认</p> -->
                <p class="deleteBtn" @click.stop="deleteAddress(index)">删除</p>
              </div>
            </li>
            <li class="addressLi" id="noUseLi">
              <div class="head">
                <img src="../assets/head.jpg" alt />
              </div>
              <div class="default">
                <img src="../assets/default.png" />
              </div>
              <ul class="addressPerUl">
                <li class="addressPerUlName"></li>
                <li class="addressPerUlAddress">地址：</li>
                <li class="addressPerUlPhone">手机号：</li>
                <li class="addressPerUlEmail">邮编：</li>
              </ul>
              <div class="operateDiv">
                <p class="editBtn">编辑</p>
                <p class="editBtn">设为默认</p>
                <p class="deleteBtn">删除</p>
              </div>
            </li>
          </ul>
        </div>
        <!-- v-show="isProblems" -->
        <div class="problems" v-if="showModel==4">
          <p class="problemTitle">常见问题</p>
          <ul class="problemUl">
            <li class="problemLi" v-for="(item,index) in questionList" :key="index" :value="index">
              <p class="problemDesc">
                <span class="problemDescSort">{{index+1}}</span>
                <span class="problemDescDetail">{{item.title}}</span>
              </p>
              <div class="problemReply">
                <!-- <span class="problemReplySpan">解答：</span> -->
                <div class="problemRight" v-html="item.content"></div>
              </div>
            </li>
          </ul>
        </div>
        <!-- v-show="isAdvice" -->
        <div class="advicePart" v-if="showModel==5">
          <p class="adviceTitle">意见反馈</p>
          <textarea
            name
            id="feedback"
            cols="30"
            rows="10"
            class="adviceTextarea"
            placeholder="希望能得到您宝贵的意见与建议"
          ></textarea>
          <p class="submitAdvice" @click="submitFeedBack">提 交</p>
        </div>
        <!-- v-show="isUpdatePerInfo" -->
        <div class="updatePerInfo" v-if="showModel==6">
          <p class="updatePerInfoTitle">修改信息</p>
          <div class="nowHeadImg">
            <p class="nowHeadImgTitle">头像：</p>
            <div class="headImgPar" title="点击修改用户头像">
              <!-- <img :src="user.headUrl?user.headUrl:imgUrl" alt="" class="nowShowImg"> -->
              <el-upload
                class="avatar-uploader"
                action="http://192.168.1.240:8080/huban-dcfadmin/file/upload"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-bind:src="imageUrl!='' && imageUrl!=undefined?imageUrl:(user.headUrl!='' &&user.headUrl!=undefined&&user.headUrl!=null?user.headUrl:imgUrl)"
                  class="avatar"
                />
                <i class="el-icon-plus avatar-uploader-icon addHeadImg"></i>
              </el-upload>
            </div>
          </div>
          <div class="updateName">
            <p class="updateNameTitle">个人昵称:</p>
            <input type="text" placeholder="请输入昵称" v-model="nickName" />
          </div>
          <!-- <div class="updatePhone">
              <p class="updatePhoneTitle">手机号码:</p>
              <input type="text" placeholder="请输入手机号">
          </div>-->
          <p class="upDatePassWord" @click="upDatePassWord()">
            <span class="upDatePassWordTitle">修改密码</span>
            <span class="el-icon-arrow-down"></span>
          </p>
          <div class="updatePasswordPart" v-show="isUpDatePassWord">
            <input type="text" placeholder="请输入手机号" class="zh" v-model="mobileNum" />
            <div class="keyNum">
              <input type="text" placeholder="请输入验证码" v-model="keyNum" />
              <div :class="timeNum<61?'grayCl':''" @click="getKey()">
                <span>{{timeNum==61?'获取验证码':timeNum+'s'}}</span>
              </div>
            </div>
            <input
              type="password"
              placeholder="请输入密码"
              v-model="input1"
              class="passwordInput"
              show-password
            />
            <input
              type="password"
              placeholder="请再次输入新密码"
              v-model="input2"
              class="passwordInputAgin"
              show-password
            />
          </div>
          <div class="saveAndSubmit" @click="submit()">保存</div>
        </div>
        <!-- v-show="isAdd" -->
        <div class="addAddress" v-if="showModel==7">
          <p class="backP">
            <span class="back el-icon-arrow-left" @click="back()">返回</span>
            <span class="addTitle">{{address.id==''||address.id==null?'添加收货地址':'修改地址'}}</span>
          </p>
          <ul>
            <li>
              <p class="liP">
                <span id="star">*</span>地址信息
              </p>
              <input type="text" placeholder="请选择地址" v-model="address.address" />
            </li>
            <li>
              <p class="liP">
                <span id="star">*</span>详细地址
              </p>
              <input type="text" placeholder="请输入详细地址" v-model="address.detailed" />
            </li>
            <li>
              <p class="liP">邮政编码</p>
              <input type="text" placeholder="请填写邮政编码" v-model="address.postal" />
            </li>
            <li>
              <p class="liP">
                <span id="star">*</span>收货人姓名
              </p>
              <input type="text" placeholder="请输入收货人姓名" v-model="address.name" />
            </li>
            <li>
              <p class="liP">
                <span id="star">*</span>手机号码
              </p>
              <input type="text" placeholder="请输入手机号" v-model="address.phone" />
            </li>
          </ul>
          <div class="save" @click="saveAddress">保存</div>
        </div>
        <div style="margin-top: 15px;" class="isPjia" v-show="showModel==8">
          <ul class="spTab">
            <li class="sp">宝贝</li>
            <li class="priceOneTab">单价</li>
            <li class="spNum">数量</li>
            <li class="spPriceTab">金额</li>
          </ul>
          <ul class="spUl" v-if="reviewOrderOne!=''">
            <li class="spLi">
              <div class="spImg">
                <img :src="reviewOrderOne.goodsEntity.imgurl.split(',')[0]" alt />
              </div>
              <div class="spName" v-text="reviewOrderOne.goodsEntity.name">常开电磁阀</div>
            </li>
            <li class="priceone" v-text="'¥'+reviewOrderOne.goodsEntity.money">￥230</li>
            <li class="allNum" v-text="reviewOrderOne.size">11</li>
            <li class="allPrice" v-text="'¥'+reviewOrderOne.money">￥460</li>
          </ul>

          <!-- <div> -->
          <!-- <div>商品评价</div> -->
          <div class="blocka">
            <span class="demonstration">商品评价</span>
            <el-rate v-model="value1"></el-rate>
          </div>
          <!-- </div> -->
          <textarea name cols="30" rows="10" class="pjArea" placeholder="商品怎么样？请输入你的评价" id="review"></textarea>
          <div class="submitPj" @click="submitReview">提交</div>
        </div>
        <div style="margin-top: 15px;" class="isPjia" v-show="showModel==9">
          <ul class="spTab">
            <li class="sp">宝贝</li>
            <li class="priceOneTab">单价</li>
            <li class="spNum">数量</li>
            <li class="spPriceTab">金额</li>
          </ul>
          <ul class="spUl" v-if="refundOrderOne!=''">
            <li class="spLi">
              <div class="spImg">
                <img :src="refundOrderOne.goodsEntity.imgurl.split(',')[0]" alt />
              </div>
              <div class="spName" v-text="refundOrderOne.goodsEntity.name">常开电磁阀</div>
            </li>
            <li class="priceone" v-text="'¥'+refundOrderOne.goodsEntity.money">￥230</li>
            <li class="allNum" v-text="refundOrderOne.size">11</li>
            <li class="allPrice" v-text="'¥'+refundOrderOne.money">￥460</li>
          </ul>

          <!-- <div> -->
          <!-- <div>商品评价</div> -->

          <!-- </div> -->
          <textarea
            name
            cols="30"
            rows="10"
            class="pjArea"
            placeholder="商品怎么样？请输入你的退货原因"
            id="refund"
          ></textarea>
          <div class="submitPj" @click="submitRefund">提交</div>
        </div>
        <div style="margin-top: 15px;" class="isPjia" v-show="showModel==10">
          <div class="wuliuTop">
            <p class="wuliuBack" @click="wuliuBack()">返回</p>
            <p class="wuliuTitle">物流信息</p>
          </div>
          <div class="wuliuMid">
            <div class="wuliuImg">
              <img :src=wuliuImg alt />
            </div>
            <div class="wuliuComp">
              <ul class="wuliuUl lefUl">
                <li class="wuliuComponay botNono">物流公司</li>
                <li class="wuliuId botNono">物流单号</li>
                <li class="wuliuId botNono">订单时间</li>
                <li class="wuliuId botNono">收货人</li>
                <li class="wuliuId botNono">收货地址</li>
                <li class="wuliuId">收货电话</li>
              </ul>
              <ul class="wuliuUl">
                <li class="wuliuComponay botNo" v-text="wuliuComponay?wuliuComponay:'暂无'">{{wuliuComponay}}</li>
                <li class="wuliuId botNo" v-text="wuliuId?wuliuId:'暂无'">{{wuliuId}}</li>
                <li class="wuliuId botNo" v-text="wuliuTime?wuliuTime:'暂无'">{{wuliuTime}}</li>
                <li class="wuliuId botNo" v-text="wuliuPeople?wuliuPeople:'暂无'">{{wuliuPeople}}</li>
                <li class="wuliuId botNo">{{wuliuAddress}}</li>
                <li class="wuliuId" v-text="wuliuPhone?wuliuPhone:'暂无'">{{wuliuPhone}}</li>
              </ul>
            </div>
          </div>
          <div class="noDataDiv" v-show="wuliuChangeInfo.length==0">
                <img src="../assets/noData.png" alt />
              </div>
              <p class="noDataP" v-show="wuliuChangeInfo.length==0">暂无物流信息，请客官耐心等待哦！</p>
          <div class="wuliuTime">
            <div class="block">
              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in wuliuChangeInfo"
                  :key="index"
                  :icon="activity.icon"
                  :type="activity.type"
                  :color="activity.color"
                  :size="activity.size"
                  :timestamp="activity.timestamp"
                >{{activity.content}}</el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import navtab from "./navtab";
export default {
  name: "perCenter",
  components: {
    navtab: navtab
  },
  inject: ["reload"],
  data() {
    return {
      timeNum: 61,
      total: "",
      newSaveList: [],
      endNewsList: [],
      currentPage: 1,
      liFlag: 1,
      isUpDatePassWord: false,
      imgUrl: require("../assets/head.jpg"),
      activeName2: "order-", //订单选中状态
      orderList: [
        {
          title: "所有订单",
          list: [],
          chooseAll: false
        },
        {
          title: "待支付",
          list: [],
          chooseAll: false
        },
        {
          title: "待收货",
          list: [],
          chooseAll: false
        },
        {
          title: "待评价",
          list: [],
          chooseAll: false
        },
        {
          title: "退货",
          list: [],
          chooseAll: false
        }
      ],
      input5: "",
      myOrder: true,
      isAdvice: false,
      isProblems: false,
      isMyAddress: false,
      isAdd: false,
      isMySave: false,
      isUpdatePerInfo: false,
      collectList: [
        { name: "商城", list: [] },
        { name: "行业动态", list: [] },
        { name: "资料库", list: [] }
      ], //收藏列表
      activeName3: "collect-", //收藏选择
      currentPage4: 1,
      currentPage5: 5,
      aaa: false,
      imageUrl: "",
      input1: "",
      input2: "",
      isPjia: false,
      value1: 5,
      showModel: 0,
      user: "",
      nickName: "",
      mobileNum: "",
      userName: "",
      keyNum: "",
      headUrl: "",
      questionList: [], //常见问题
      addressList: [], //地址列表
      address: {
        address: "",
        name: "",
        detailed: "",
        phone: "",
        postal: ""
      }, //修改增加地址
      reviewOrderOne: "", //评价订单
      refundOrderOne: "", //退款订单
      wuliuInfo: "",
      orderInfo: "",
      orderInfo: "",
      wuliuPeople: "", //收货人
      wuliuPhone: "", //收货电话
      wuliuAddress: "", //收货地址
      wuliuImg: "", //物品图片
      wuliuName: "", //产品名称
      wuliuTime: "", //订单生成的时间
      wuliuId: "", //物流单号
      wuliuChangeInfo: [], //物流的状态信息更新时间
      wuliuComponay: "" //物流公司
    };
  },

  methods: {
    wuliuBack() {
      this.showModel = 1;
    },
    // seeWuliu(index,num){
    seeWuliu(index, num) {
      this.showModel = 10;
      var that=this;
      // index对应是哪个模块下的订单数组，
      // num 对应是哪个订单
      this.orderInfo=this.orderList[index].list[num];
      //console.log(this.orderInfo);
      this.wuliuPeople=this.orderInfo.name; //收货人
      this.wuliuAddress=this.orderInfo.address +this.orderInfo.detailed; //收货地址
      this.wuliuPhone=this.orderInfo.phone; //收货电话
      this.wuliuName=this.orderInfo.goodsEntity.name; //产品名称
      this.wuliuTime=this.orderInfo.createtime; //订单生成的时间
      $.ajax({
        url: this.$http + "/api/kdnAPI/getWuLiu",
        type: "GET",
        cache: false,
        data: {
          expCode: this.orderInfo.expressNameab, //快递二维码  expressNameab
          expNo: this.orderInfo.expressNumber, //快递单号 expressNumber
          phone: this.orderInfo.phone //收货手机号 phone
        },
/*         data: {
          expCode: 'yunda', //快递二维码  expressNameab
          expNo: 3801861390153, //快递单号 expressNumber
          phone: 13606509653 //收货手机号 phone
        }, */
        contentType: "application/JSON",
        success: function(res) {
          that.wuliuImg= that.orderInfo.goodsEntity.imgurl.split(',')[0]; //物品图片
          that.wuliuInfo = JSON.parse(res);
          //console.log(that.wuliuInfo);
          that.wuliuComponay = that.wuliuInfo.com; //物流公司
          that.wuliuId = that.wuliuInfo.nu; //物流单号
          var wuliuChangeInfoArr = that.wuliuInfo.data; //物流的状态信息更新时间
          wuliuChangeInfoArr.forEach((element, index) => {
            //console.log(index, element);
            var obj = {};
            if (index == 0) {
              obj = {
                content: element.context,
                timestamp: element.time, //时间戳	string
                size: "large", //节点尺寸	string	normal / large	normal
                type: "primary", //节点类型	string	primary / success / warning / danger / info
                color: "#158DD3" //节点颜色	string	hsl / hsv / hex / rgb
                // icon: "el-icon-more" 节点图标	string
              };
            } else {
              obj = {
                content: element.context,
                timestamp: element.time, //时间戳	string
                size: "large", //节点尺寸	string	normal / large	normal
                type: "primary", //节点类型	string	primary / success / warning / danger / info
                color: "#ccc" //节点颜色	string	hsl / hsv / hex / rgb
                // icon: "el-icon-more" 节点图标	string
              };
            }
            //console.log(that.collectList);
            that.wuliuChangeInfo.push(obj);
          });
        },
        error: function() {}
      });
    },
    //获取收藏列表
    getCollectList() {
      var index = parseInt(this.activeName3.split("-")[1]);
      //console.log(index, this.activeName3);
      var obj = { type: index + 1, userName: this.user.userName };
      this.$axios({
        method: "POST",
        url: this.$http + "/api/personal/collectSelect",
        data: obj,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          this.collectList[index].list = data.Entity;
          //console.log(this.collectList[index].list);
          //console.log(this.collectList);
          this.newSaveList = this.collectList[index].list;
          //console.log(this.newSaveList);
          this.total = this.newSaveList.length;
          //console.log(this.total);
          this.changePage(this.currentPage);
        } else {
          // alert(data.msg);
          this.$notify.info({
            title: "消息",
            message: data.msg
          });
        }
      });
    },
    handleClick(tab, event) {
      //console.log(this.newSaveList);
    },
    changePage(currentPage) {
      //console.log(currentPage);
      //console.log(this.newSaveList);
      this.currentPage = currentPage;
      //console.log(currentPage);
      let start = 20 * (this.currentPage - 1);
      let end = 20 * (this.currentPage - 1) + 20;
      //console.log(start, end);
      this.endNewsList = this.newSaveList.slice(start, end);
      //console.log(this.endNewsList);
    },
    outLogin() {
      this.user = "";
      //console.log(JSON.parse(sessionStorage.getItem("user")));
      sessionStorage.setItem("user", "");
      //console.log(sessionStorage.getItem("user"));
      // window.location.href = "/";
      this.$router.push("/");
      // this.reload();
    },
    toDetail(index, id) {
      //console.log("111");
      //console.log(index); //index=0 商城 1 行业动态 2资料库
      //console.log(id);
      sessionStorage.setItem("routerDetailId", JSON.stringify(id));
      if (index == 0) {
        // var fromPath= "/perCenter";
        //  sessionStorage.setItem("fromPath", JSON.stringify(fromPath));
        //  //console.log(JSON.parse(sessionStorage.getItem("fromPath")));
        // alert("跳转到商品详情");
        this.$notify.info({
          title: "消息",
          message: "即将前往商品详情页面"
        });
        this.$router.push("/shopping");
      } else if (index == 1) {
        // alert("跳转到行业动态详情");
        this.$notify.info({
          title: "消息",
          message: "即将前往行业动态详情页面"
        });
        this.$router.push("/hyActivityDetail/1/" + id);
      } else if (index == 2) {
        // alert("跳转到资料库详情");
        this.$notify.info({
          title: "消息",
          message: "即将前往资料库详情页面"
        });
        this.$router.push("/database");
      }
    },
    upDatePassWord() {
      this.isUpDatePassWord = !this.isUpDatePassWord;
      //console.log(this.isUpDatePassWord);
    },
    showMyorder() {
      this.showModel = 1;
      this.liFlag = 1;
    },
    showMysave() {
      this.showModel = 2;
      this.liFlag = 2;
    },
    showMyaddress() {
      this.showModel = 3;
      this.liFlag = 3;
    },
    showProBlem() {
      this.showModel = 4;
      this.liFlag = 4;
    },
    showAdvice() {
      this.showModel = 5;
      this.liFlag = 5;
    },
    updatePerInfo() {
      this.showModel = 6;
    },
    addAddress() {
      this.address = {};
      this.showModel = 7;
    },
    back() {
      var isAddAddress = 2;
      sessionStorage.setItem("isAddAddress", isAddAddress);
      this.showModel = 3;
    },
    //标签页
    handleSizeChange(val) {
      //console.log(`收藏中的每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      //console.log(`收藏中的当前页: ${val}`);
    },
    toHyActivityDetail() {
      this.$router.push("/hyActivityDetail");
    },
    //导航菜单
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    isShowDetail() {
      this.aaa = true;
      //   alert('111')
    },
    // 图片上传
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 图片上传成功的回调
    handleAvatarSuccess(res, file) {
      //console.log(res);
      //console.log(file);
      if (res.code == 0) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.headUrl = res.data.src;
        //console.log(this.imageUrl, this.headUrl);
        // alert("上传头像成功");
      }
    },
    // 获取验证码  /api/login/code/{userName}/{type} type=1为注册 2为忘记密码
    getKey() {
      if (this.timeNum < 61) {
        return;
      }
      var that = this;
      function countDown() {
        that.timeNum = that.timeNum - 1;
        //console.log(that.timeNum);
        if (that.timeNum == 0) {
          that.timeNum = 61;
          return;
        }
        setTimeout(function() {
          countDown();
        }, 1000);
      }
      countDown();
      this.$axios
        .get(this.$http + "api/login/code/" + this.mobileNum + "/" + 2)
        .then(res => {
          //console.log(res);
          if (res.data.code == 500) {
            // alert("验证码已发送，请等待");
            this.$notify({
              title: "成功",
              message: "验证码已发送，请等待",
              type: "success"
            });
          } else {
            // alert("获取验证码失败");
            this.$notify.info({
              title: "消息",
              message: "获取验证码失败,请重新获取"
            });
          }
        })
        .catch(err => {});
      // }
    },
    // 修改个人信息 /api/personal/updateUser修改个人资料
    submit() {
      let obj = {};
      let data = "";
      if (this.input1) {
        if ((this.input1 = this.input2)) {
          obj = {
            nickName: this.nickName,
            passWord: this.input2,
            headUrl: this.headUrl,
            code: this.keyNum,
            userId: this.user.userId
          };
          //console.log(obj);
          data = JSON.stringify(obj);
        } else {
          this.$notify.error({
            title: "错误",
            message: "密码不一致，请重新输入！"
          });
        }
      } else {
        obj = {
          headUrl: this.headUrl,
          nickName: this.nickName,
          userId: this.user.userId
        };
        //console.log(obj);
        data = JSON.stringify(obj);
      }
      this.$axios({
        method: "post",
        url: this.$http + "api/personal/updateUser",
        headers: {
          "Content-Type": "application/json"
        },
        data: data
      })
        .then(res => {
          //console.log(res);
          if (res.data.code == 0) {
            // alert("修改成功");
            this.$notify({
              title: "成功",
              message: "修改成功",
              type: "success"
            });
            this.getPerInfo();
          } else {
            this.$notify({
              title: "消息",
              message: "修改失败",
              type: "warning"
            });
          }
        })
        .catch(err => {});
    },
    // /api/personal/userInfo/{userName}通过用户名获取个人信息
    getPerInfo() {
      this.$axios
        .get(this.$http + "api/personal/userInfo/" + this.user.userName)
        .then(res => {
          //console.log(res);
          if (res.data.code == 0) {
            let user = res.data.userInfoEntity;
            sessionStorage.setItem("user", JSON.stringify(user));
            this.reload();
            // return;
          } else {
            // alert("获取个人信息失败");
            // //console.log("通过用户名获取个人信息失败");
            this.$notify({
              title: "消息",
              message: "通过用户名获取个人信息失败",
              type: "warning"
            });
          }
        })
        .catch(err => {});
    },
    //常见问题
    helpQUestion() {
      this.$axios({
        method: "POST",
        url: this.$http + "/api/personal/help",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        var data = res.data;
        if (data.code == 0) {
          this.questionList = data.Entity;
        }
      });
    },

    //意见反馈提交
    submitFeedBack() {
      if ($("#feedback").val()) {
        this.$axios({
          method: "POST",
          url: this.$http + "/api/personal/feedback",
          headers: {
            "Content-Type": "application/json"
          },
          data: { userName: this.user.userName, content: $("#feedback").val() }
        }).then(res => {
          var data = res.data;
          if (data.code == 0) {
            $("#feedback").val("");
            // alert("提交成功");
            this.$notify({
              title: "成功",
              message: "提交成功",
              type: "success"
            });
          } else {
            this.$notify({
              title: "消息",
              message: "提交失败，麻烦小主再重新提交！",
              type: "warning"
            });
          }
        });
      } else {
        this.$notify({
          title: "消息",
          message: "内容不能为空！",
          type: "warning"
        });
      }
    },

    //获取地址
    getAddress() {
      this.$axios({
        method: "GET",
        url:
          this.$http + "/api/personal/SelectUserAddress/" + this.user.userName,
        // data: {
        //   id: that.shopcartList[index].id,
        //   size: size,
        //   money: size * parseFloat(that.shopcartList[index].price),
        //   userName: that.user.userName
        // },
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          this.addressList = data.Entity;
        }
      });
    },

    //地址设为默认
    setDefault(index) {
      var obj = JSON.parse(JSON.stringify(this.addressList[index]));
      obj.type = 1;
      this.$axios({
        method: "POST",
        url: this.$http + "/api/personal/InsertOrUpdateUserAddress",
        data: obj,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          this.$axios({
            method: "GET",
            url:
              this.$http +
              "/api/personal/SelectUserAddress/" +
              this.user.userName,
            // data: {
            //   id: that.shopcartList[index].id,
            //   size: size,
            //   money: size * parseFloat(that.shopcartList[index].price),
            //   userName: that.user.userName
            // },
            headers: {
              "Content-Type": "application/json"
            }
          }).then(res => {
            //console.log(res);
            var data = res.data;
            if (data.code == 0) {
              this.addressList = data.Entity;
            }
          });
        }
      });
    },

    //删除地址
    deleteAddress(index) {
      this.$axios({
        method: "POST",
        url:
          this.$http +
          "/api/personal/DelUserAddress/" +
          this.addressList[index].id,
        // data: obj,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          this.$axios({
            method: "GET",
            url:
              this.$http +
              "/api/personal/SelectUserAddress/" +
              this.user.userName,
            // data: {
            //   id: that.shopcartList[index].id,
            //   size: size,
            //   money: size * parseFloat(that.shopcartList[index].price),
            //   userName: that.user.userName
            // },
            headers: {
              "Content-Type": "application/json"
            }
          }).then(res => {
            //console.log(res);
            var data = res.data;
            if (data.code == 0) {
              this.addressList = data.Entity;
            }
          });
        }
      });
    },

    //编辑地址
    editAddress(index) {
      this.address = this.addressList[index];
      this.showModel = 7;
    },

    //保存修改地址
    saveAddress() {
      // var isAddAddress = 2;
      // sessionStorage.setItem("isAddAddress", isAddAddress);
      var obj = this.address;
      obj.userName = this.user.userName;
      this.$axios({
        method: "POST",
        url: this.$http + "/api/personal/InsertOrUpdateUserAddress",
        data: obj,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          this.$notify({
            title: "成功",
            message: "操作成功",
            type: "success"
          });
          this.showModel = 3;
          if (sessionStorage.getItem("isAddAddress") == 1) {
            this.$router.push("/shopping");
          }
        } else {
          // alert(data.msg);
          this.$notify({
            title: "消息",
            message: data.msg,
            type: "warning"
          });
        }
      });
    },
    //获取所有订单
    getOrderList() {
      this.$axios({
        method: "GET",
        url: this.$http + "/api/Shopping/OrderByList/" + this.user.userName,
        // data: obj,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          for (var i = 0; i < data.Entity.length; i++) {
            data.Entity[i].choose = false;
            data.Entity[i].price = (
              parseFloat(data.Entity[i].money) / parseFloat(data.Entity[i].size)
            ).toFixed(2);
          }
          this.orderList[0].list = JSON.parse(
            JSON.stringify(data.Entity.reverse())
          );
          for (var i = 1; i < this.orderList.length; i++) {
            this.getOneTypeOrderList(i, this.orderList[0].list);
          }
        } else {
          // alert(data.msg);
          this.$notify.info({
            title: "消息",
            message: data.msg
          });
        }
      });
    },

    //获取每个分类下的订单
    getOneTypeOrderList: function(index, data) {
      if (data.length > 0) {
        this.orderList[index].list = [];
        for (var i = 0; i < data.length; i++) {
          if (index < 4) {
            if (data[i].type == index) {
              this.orderList[index].list.push(data[i]);
            }
          } else {
            if (data[i].type == 0) {
              this.orderList[index].list.push(data[i]);
            }
          }
        }
      } else {
        this.orderList[index].list = data;
      }
    },

    //订单模糊查询
    queryOrderKey(data) {
      var arr = JSON.parse(JSON.stringify(data));
      var nowArr = [];
      if (this.input5 == "") {
        nowArr = arr;
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].goodsEntity.name.indexOf(this.input5) != -1) {
            nowArr.push(arr[i]);
          }
        }
      }
      return nowArr;
    },

    //选中订单
    chooseOrderOne(index, num) {
      //console.log(index, num, this.orderList[index].list);
      if (num == -1) {
        this.orderList[index].chooseAll = !this.orderList[index].chooseAll;
        //console.log(this.orderList[index].chooseAll);
        for (var i = 0; i < this.orderList[index].list.length; i++) {
          this.orderList[index].list[i].choose = this.orderList[
            index
          ].chooseAll;
        }
        this.$forceUpdate();
      } else {
        this.orderList[index].list[num].choose = !this.orderList[index].list[
          num
        ].choose;
        this.decideStatus(index);
      }
    },

    //判断某个状态下订单时候全选
    decideStatus(index) {
      for (var j = 0; j < this.orderList[index].list.length; j++) {
        if (this.orderList[index].list[j].choose == false) {
          this.orderList[index].chooseAll = false;
          break;
        }
      }
      if (j == this.orderList[index].list.length) {
        this.orderList[index].chooseAll = true;
      }
      this.$forceUpdate();
    },

    //删除订单
    deleteOrder(index, num) {
      this.$confirm("真的忍心删除这个订单吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$axios({
            method: "POST",
            url:
              this.$http +
              "api/Shopping/OrderDelPay/" +
              this.orderList[index].list[num].id
            // data: obj,
            // headers: {
            //   "Content-Type": "application/json"
            // }
          }).then(res => {
            //console.log(res);
            var data = res.data;
            if (data.code == 0) {
              this.orderList[index].list.splice(num, 1);
              this.$notify({
                title: "温馨提示",
                message: "已取消",
                type: "success"
              });
            }
          });
        })
        .catch(() => {
          this.$notify({
            title: "温馨提示",
            message: "已取消",
            type: "warning"
          });
        });
      return;
    },

    deleteAll(index) {
      var arr = [];
      for (var i = 0; i < this.orderList[index].list.length; i++) {
        if (this.orderList[index].list[i].choose) {
          arr.push(this.orderList[index].list[i].id);
        }
      }
      //console.log(arr, this.orderList[index]);
      if (arr.length > 0) {
        this.deleteOrderOne(index, 0, arr);
      } else {
        // alert("请选中删除订单");
        this.$notify.info({
          title: "消息",
          message: "请选中删除订单"
        });
      }
    },

    confirmAll(index) {
      var arr = [];
      for (var i = 0; i < this.orderList[index].list.length; i++) {
        if (this.orderList[index].list[i].choose) {
          arr.push(this.orderList[index].list[i].id);
        }
      }
      //console.log(arr, this.orderList[index]);
      if (arr.length > 0) {
        this.confirmOrderOne(index, 0, arr);
      } else {
        // alert("请选中收货订单");
        this.$notify.info({
          title: "消息",
          message: "请选中删除订单"
        });
      }
    },

    //删除订单中的一个
    deleteOrderOne(index, num, arr) {
      var that = this;
      return new Promise(resolve => {
        this.$axios({
          method: "POST",
          url: this.$http + "api/Shopping/OrderDelPay/" + arr[num]
          // data: obj,
          // headers: {
          //   "Content-Type": "application/json"
          // }
        }).then(res => {
          //console.log(res);
          var data = res.data;
          if (data.code == 0) {
            for (var i = 0; i < that.orderList[index].list.length; i++) {
              if (arr[num] == that.orderList[index].list[i].id) {
                that.orderList[index].list.splice(i, 1);
              }
            }
            that.$forceUpdate();
            num = parseFloat(num) + 1;
            if (num < arr.length) {
              return that.deleteOrderOne(index, num, arr);
            }
          }
        });
      });
    },

    //收获全部订单
    confirmOrderOne(index, num, arr) {
      var that = this;
      return new Promise(resolve => {
        this.$axios({
          method: "POST",
          url: this.$http + "api/Shopping/OrderUpd/" + arr[num]
          // data: obj,
          // headers: {
          //   "Content-Type": "application/json"
          // }
        }).then(res => {
          //console.log(res);
          var data = res.data;
          if (data.code == 0) {
            num = parseFloat(num) + 1;
            if (num < arr.length) {
              return that.confirmOrderOne(index, num, arr);
            } else {
              that.getOrderList();
            }
          }
        });
      });
    },

    //去支付
    goPay(index, num) {
      var order = [];
      order.push(this.orderList[index].list[num]);
      sessionStorage.order = JSON.stringify(order);

      this.$router.push("/shopping");
      sessionStorage.isDetail = 4;
    },

    //确认收货
    confirmOrder(index, num) {
      this.$axios({
        method: "POST",
        url:
          this.$http +
          "api/Shopping/OrderUpd/" +
          this.orderList[index].list[num].id
        // data: obj,
        // headers: {
        //   "Content-Type": "application/json"
        // }
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          this.getOrderList();
        }
      });
    },

    //选择评价订单
    reviewOrder(index, num) {
      this.showModel = 8;
      this.reviewOrderOne = this.orderList[index].list[num];
    },

    //选择退款订单
    refundOrder(index, num) {
      this.showModel = 9;
      this.refundOrderOne = this.orderList[index].list[num];
    },

    //提交评价
    submitReview() {
      //console.log($("#review").val());
      if (
        $("#review").val() != "" &&
        $("#review").val() != null &&
        $("#review").val() != undefined &&
        $("#review").val() != ""
      ) {
        var obj = {
          userName: this.user.userName,
          orderid: this.reviewOrderOne.id,
          goodId: this.reviewOrderOne.goodsEntity.id,
          content: $("#review").val(),
          star: this.value1
        };
        this.$axios({
          method: "POST",
          url: this.$http + "api/Shopping/OrderEvaluation",
          data: obj,
          headers: {
            "Content-Type": "application/json"
          }
        }).then(res => {
          //console.log(res);
          var data = res.data;
          if (data.code == 0) {
            this.showModel = 1;
            this.getOrderList();
          }
        });
      } else {
        this.$notify({
          title: "警告",
          message: "不能为空",
          type: "warning"
        });
      }
    },

    //提交退款原因
    submitRefund() {
      var obj = {
        address: "",
        buyerReason: $("#refund").val(),
        category: 1,
        detailed: "",
        goodsId: this.refundOrderOne.goodsId,
        goodsspecid: this.refundOrderOne.goodsspecid,
        id: this.refundOrderOne.id,
        userName: this.user.userName
      };
      this.$axios({
        method: "POST",
        url: this.$http + "api/Shopping/OrderDrawback",
        data: obj,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res => {
        //console.log(res);
        var data = res.data;
        if (data.code == 0) {
          this.showModel = 1;
          $("#refund").val();
          this.getOrderList();
        }
      });
    }
  },

  created() {},
  mounted() {
    if (JSON.parse(sessionStorage.getItem("user"))) {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      //console.log(this.user);
    } else {
      this.$notify({
        title: "温馨提示",
        message: "为了给您更加优质的服务，请先登录",
        type: "warning"
      });
      this.$router.push("/");
    }

    this.showModel = 1;
    // this.getPerInfo();
    if (
      sessionStorage.getItem("isAddAddress") &&
      sessionStorage.getItem("isAddAddress") == 1
    ) {
      this.showModel = 7;
      this.liFlag = 3;
    }
  },
  watch: {
    showModel: {
      handler(newVal, oldVal) {
        if (newVal == 1) {
          this.activeName2 = "order-0";
        } else if (newVal == 2) {
          this.activeName3 = "collect-0";
        } else if (newVal == 3) {
          this.getAddress();
        } else if (newVal == 4) {
          this.helpQUestion();
        } else if (newVal == 5) {
        } else if (newVal == 6) {
        } else if (newVal == 7) {
        } else if (newVal == 8) {
          $("#review").val("");
        }
      }
    },
    activeName3(newVal, oldVal) {
      //console.log(newVal);
      this.getCollectList();
    },

    activeName2(newVal, oldVal) {
      for (var i = 0; i < this.orderList.length; i++) {
        this.orderList[i].chooseAll = false;
      }
      this.getOrderList();
    }
  }
};
</script>

<style>
.perCenter .noDataDiv {
  width: 98px;
  height: 86px;
  /* background-color: pink; */
  margin: 0 auto;
  margin-top: 10%;
}
.perCenter .noDataP {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-top: 17px;
}
.perCenter .noDataDiv img {
  display: block;
  width: 100%;
  height: 100%;
}
/* 收藏中的分页所在的位置 */
.el-pagination {
  white-space: nowrap;
  padding: 2px 5px;
  color: #303133;
  font-weight: 700;
  margin-top: 138px;
}
#star {
  color: red;
}
.el-input-group__append {
  border-left: 0;
  background-color: #158dd3;
  color: #fff;
}
.el-input-group {
  line-height: normal;
  display: inline-table;
  width: 47%;
  border-collapse: separate;
  border-spacing: 0;
  position: absolute;
  left: 0;
  top: 0;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #fff;
  border-bottom: 2px solid #158dd3;
}
.el-tabs--card > .el-tabs__header .el-tabs__item:first-child {
  border-left: none;
}
.el-tabs--card > .el-tabs__header .el-tabs__item {
  font-size: 12px;
  font-weight: 400;
  border-bottom: 1px solid transparent;
  border-left: 1px solid #e4e7ed;
  -webkit-transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 15px 10px;
  padding-left: 20px;
}
.el-tabs__content {
  margin: 0 0 0 18px;
}
#out {
  border: 0;
  font-weight: 600;
  /* text-decoration: underline; */
  width: 72%;
  /* padding:0 6px; */
  /* height: 30px;
  line-height: 30px; */
  border: 2px solid #158dd3;
  color: #fff;
  background-color: #158dd3;
}
.perCenter {
  background-color: rgba(245, 245, 245, 1);
  min-height: 100vh;
}
.perCenter .navTab {
  box-shadow: 0px 4px 8px 0px rgba(102, 102, 102, 0.2);
  z-index: 999;
}
.perCenter .bigPar {
  width: 80%;
  margin: 0 auto;
  /* background-color: pink; */
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 1%;
}
.perCenter .bigPar .lef {
  width: 23%;
  margin: 0 1%;
}
.perCenter .bigPar .lef .lefTop {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-top: 10%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 9px 20px 0px rgba(92, 92, 92, 0.1);
}
.perCenter .bigPar .lef .lefTop .perHead {
  width: 91px;
  height: 91px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
}
.perCenter .bigPar .lef .lefTop .perHead img {
  display: block;
  width: 100%;
  height: 100%;
}
.perCenter .bigPar .lef .lefTop .perName {
  width: 100%;
  text-align: center;
  margin: 3% auto;
  font-size: 16px;
}
.el-tabs--card > .el-tabs__header .el-tabs__item {
  border-left: 0 !important;
}
.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0;
}
.perCenter .bigPar .lef .lefTop .perPhone {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  font-size: 14px;
  color: #ccc;
}
.perCenter .bigPar .lef .lefTop .updateBtn {
  width: 33%;
  margin: 3% auto;
  text-align: center;
  height: 38px;
  line-height: 38px;
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid rgb(204, 204, 204);
  cursor: pointer;
}
.perCenter .bigPar .lef .lefBottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  /* background-color: yellow; */
}
.perCenter .bigPar .lef .lefBottom li {
  width: 31%;
  height: 104px;
  background-color: #fff;
  margin: 3% 0;
  /* padding-top: 3%; */
  cursor: pointer;
  border: 1px solid transparent;
  box-shadow: 0px 9px 20px 0px rgba(92, 92, 92, 0.1);
}
.perCenter .bigPar .lef .lefBottom li .aaa {
  width: 100%;
  text-align: center;
  font-size: 34px;
  color: #666666;
  margin-top: 27px;
}
.perCenter .bigPar .lef .lefBottom li .bbb {
  width: 100%;
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
  color: #666666;
}
#nouse {
  background-color: transparent;
  opacity: 0;
}
.perCenter .bigPar .rig {
  width: 66%;
  background-color: #fff;
  /* padding: 10px; */
  padding-top: 0;
}
.perCenter .bigPar .rig .isPjia {
  width: 100%;
  /* background-color: pink; */
}
.perCenter .bigPar .rig .isPjia .spTab {
  width: 100%;
  height: 40px;
  background-color: #fbfbfb;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.perCenter .bigPar .rig .isPjia .spTab .sp {
  height: 100%;
  line-height: 40px;
  width: 40%;
}
.perCenter .bigPar .rig .isPjia .spTab .priceOneTab {
  height: 100%;
  line-height: 40px;
  width: 20%;
}
.perCenter .bigPar .rig .isPjia .spTab .spNum {
  height: 100%;
  line-height: 40px;
  width: 20%;
}
.perCenter .bigPar .rig .isPjia .spTab .spPriceTab {
  height: 100%;
  line-height: 40px;
  width: 20%;
}
.perCenter .bigPar .rig .isPjia .spUl {
  width: 100%;
  /* background-color: #ccc; */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border: 1px solid #f1f1f1;
  margin-bottom: 10px;
  border-top: 0;
}
.perCenter .bigPar .rig .isPjia .spUl .spLi {
  width: 40%;
  height: 200px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.perCenter .bigPar .rig .isPjia .spUl .spLi .spImg {
  height: 100%;
  width: 40%;
}
.perCenter .bigPar .rig .isPjia .spUl .spLi .spImg img {
  display: block;
  width: 100%;
  height: 100%;
}
.perCenter .bigPar .rig .isPjia .spUl .spLi .spName {
  width: 60%;
  height: 100%;
  line-height: 24px;
  font-size: 18px;
  text-align: left;
  /* text-indent: 1em; */
  word-wrap: break-word;
  padding-left: 3px;
}
.perCenter .bigPar .rig .isPjia .spUl .priceone {
  width: 20%;
  height: 100%;
  line-height: 200px;
  text-align: center;
  font-size: 16px;
  border-left: 1px solid #f5f5f5;
  border-right: 1px solid #f5f5f5;
}
.perCenter .bigPar .rig .isPjia .spUl .allNum {
  width: 20%;
  height: 100%;
  line-height: 200px;
  text-align: center;
  font-size: 16px;
  border-right: 1px solid #f5f5f5;
}
.perCenter .bigPar .rig .isPjia .spUl .allPrice {
  width: 20%;
  height: 100%;
  line-height: 200px;
  text-align: center;
  font-size: 16px;
  color: red;
  font-weight: 600;
}
.perCenter .bigPar .rig .isPjia .blocka {
  /* background-color: green; */
  font-size: 22px;
  margin-top: 30px;
  height: 126px;
}
.perCenter .bigPar .rig .isPjia .blocka .el-rate__icon {
  font-size: 40px;
  margin-top: 20px;
}
.perCenter .bigPar .rig .isPjia .pjArea {
  width: 80%;
  margin: 0 auto;
  height: 200px;
  background-color: transparent;
  font-size: 16px;
  padding: 10px;
  outline: none;
  border: 0;
  border-top: 1px solid #f1f1f1;
}
.perCenter .bigPar .rig .submitPj {
  width: 14%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  margin: 5% auto;
  background-color: #158dd3;
}
.perCenter .bigPar .rig .morePart {
  width: 100%;
  height: 38px;
  margin: 0 auto;
  margin-top: 50px;
  position: relative;
}
.perCenter .bigPar .rig .morePart .checkboxDiv {
  position: absolute;
  left: 1%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.perCenter .bigPar .rig .morePart .checkboxDiv input {
  height: 50%;
  width: 16px;
  margin-top: 14%;
  margin-right: 10px;
  -webkit-appearance: radio;
  /* transform: translateY(-50%); */
}
.perCenter .bigPar .rig .morePart .checkboxDiv .checkboxP {
  height: 38px;
  line-height: 38px;
}
.perCenter .bigPar .rig .morePart .mostYes {
  /* width: 10%; */
  text-align: center;
  font-size: 12px;
  height: 100%;
  line-height: 38px;
  position: absolute;
  right: 2%;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  padding: 0 10px;
}
.perCenter .bigPar .rig .morePart .mostDele {
  /* width: 10%; */
  text-align: center;
  font-size: 12px;
  height: 100%;
  line-height: 38px;
  position: absolute;
  right: 2%;
  border: 1px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  padding: 0 10px;
}
.perCenter .bigPar .rig .tabList {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 10px;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  background-color: #f7f7f7;
}
.perCenter .bigPar .rig .tabList li {
  height: 100%;
}
.perCenter .bigPar .rig .tabList .pro {
  width: 30%;
  /* background-color: gray; */
  text-align: center;
}
.perCenter .bigPar .rig .tabList .onePrice {
  width: 15%;
  /* background-color: red; */
  text-align: center;
}
.perCenter .bigPar .rig .tabList .num {
  width: 15%;
  /* background-color: blue; */
  text-align: center;
}
.perCenter .bigPar .rig .tabList .realPrice {
  width: 17%;
  /* background-color: yellowgreen; */
  text-align: center;
}
.perCenter .bigPar .rig .tabList .status {
  width: 8%;
  /* background-color: black; */
  text-align: center;
}
.perCenter .bigPar .rig .tabList .operateTab {
  width: 20%;
  /* background-color: green; */
  text-align: center;
}
.perCenter .bigPar .rig .orderList {
  width: 99%;
  border: 1px solid #e4effe;
  margin: 20px auto;
}
.perCenter .bigPar .rig .orderList .proOperateTab {
  position: relative;
  width: 100%;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background-color: #e4effe;
  /* color: white; */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  font-size: 12px;
}
.perCenter .bigPar .rig .orderList .proOperateTab input {
  width: 16px;
  height: 16px;
  /* 将checkbox变为圆圈 */
  -webkit-appearance: radio;
  border-radius: 50%;
  display: block;
  overflow: hidden;
  position: absolute;
  left: 1%;
  top: 50%;
  transform: translateY(-50%);
}
.perCenter .bigPar .rig .orderList .proOperateTab .time {
  height: 100%;
  left: 4%;
  /* width: 30%; */
  position: absolute;
}
.perCenter .bigPar .rig .orderList .proOperateTab .proSortNum {
  height: 100%;
  position: absolute;
  left: 14%;
}
.perCenter .bigPar .rig .orderList .proOperateTab .deleteBtn {
  height: 100%;
  position: absolute;
  right: 1%;
  line-height: 30px;
  cursor: pointer;
}
.perCenter .bigPar .rig .orderList .proOperateTab .deleteBtn:hover {
  color: red;
  font-weight: 600;
}
.perCenter .bigPar .rig .orderList .proPart {
  display: flex;
  flex-direction: row;
  justify-content: start;
  /* margin-top: 20px; */
}
.perCenter .bigPar .rig .orderList .proPart .proPartLef {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 60%;
  /* background-color: blue; */
}
.perCenter .bigPar .rig .orderList .proPart .proPartLef .proPartLefUl {
  display: flex;
  flex-direction: row;
  justify-content: start;
  width: 100%;
  /* margin: 0 0 10px 0; */
}
.perCenter
  .bigPar
  .rig
  .orderList
  .proPart
  .proPartLef
  .proPartLefUl
  .goodsImg {
  width: 20%;
  height: 100%;
}
.perCenter
  .bigPar
  .rig
  .orderList
  .proPart
  .proPartLef
  .proPartLefUl
  .goodsImg
  img {
  display: block;
  width: 100%;
  height: 100%;
}
.perCenter
  .bigPar
  .rig
  .orderList
  .proPart
  .proPartLef
  .proPartLefUl
  .goodsName {
  width: 30%;
  text-align: left;
  white-space: normal;
  font-size: 14px;
  padding-left: 3px;
  line-height: 20px;
  /* background-color: red; */
  padding-top: 10px;
}
.perCenter
  .bigPar
  .rig
  .orderList
  .proPart
  .proPartLef
  .proPartLefUl
  .goodsPrice {
  width: 25%;
  /* background-color: yellow; */
  padding-top: 10px;
}
.perCenter
  .bigPar
  .rig
  .orderList
  .proPart
  .proPartLef
  .proPartLefUl
  .goodsNum {
  width: 25%;
  /* background-color: green; */
  padding-top: 10px;
  border-right: 1px solid #e4effe;
}
.perCenter .bigPar .rig .orderList .proPart .totalPrice {
  width: 17%;
  font-weight: 600;
  font-size: 16px;
  color: black;
  padding-top: 10px;
  border-right: 1px solid #e4effe;
}
.perCenter .bigPar .rig .orderList .proPart .goodsStatus {
  width: 8%;
  font-size: 14px;
  padding-top: 10px;
  border-right: 1px solid #e4effe;
}
.perCenter .bigPar .rig .orderList .proPart .goodsOperate {
  width: 20%;
  line-height: 36px;
  padding-top: 10px;
}
.perCenter .bigPar .rig .orderList .proPart .goodsOperate p {
  cursor: pointer;
}
.perCenter .bigPar .rig .orderList .proPart .goodsOperate p:hover {
  color: red;
  font-weight: 600;
}
input {
  cursor: pointer;
}
.perCenter .bigPar .rig .advicePart {
  width: 100%;
}
.perCenter .bigPar .rig .advicePart .adviceTitle {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  font-size: 16px;
  line-height: 36px;
  border-bottom: 1px solid #ccc;
}
.perCenter .bigPar .rig .advicePart .adviceTextarea {
  width: 90%;
  margin: 0 auto;
  margin-top: 23px;
  text-indent: 1em;
  text-align: justify;
  text-align-last: left;
  line-height: 30px;
  font-size: 15px;
  padding: 4px;
  color: #4c4c4c;
  resize: none;
  border: 1px solid#e2e0e0;
  border-radius: 6px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  /* color:rgba(153,153,153,1); */
}
.perCenter .bigPar .rig .advicePart .submitAdvice {
  width: 18%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  background-color: #158dd3;
  margin: 3% auto;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
.perCenter .bigPar .rig .problems {
  width: 100%;
}
.perCenter .bigPar .rig .problems .problemTitle {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  font-size: 14px;
  line-height: 36px;
  border-bottom: 1px solid #ccc;
}
.perCenter .bigPar .rig .problems .problemUl {
  width: 80%;
  margin: 0 auto;
  margin-top: 30px;
}
.perCenter .bigPar .rig .problems .problemUl .problemLi {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-left: 1%;
  padding-top: 20px;
  padding-bottom: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin: 15px auto;
  padding: 7px 0;
  padding-left: 15px;
}
.perCenter .bigPar .rig .problems .problemUl .problemLi .problemDesc {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  font-size: 18px;
  height: 26px;
  line-height: 26px;
  font-weight: 400;
  color: #158dd3;
  margin-bottom: 20px;
}
.perCenter
  .bigPar
  .rig
  .problems
  .problemUl
  .problemLi
  .problemDesc
  .problemDescSort {
  display: inline-block;
  color: #fff;
  width: 20px;
  height: 20px;
  line-height: 20px;
  background-color: #158dd3;
  border-radius: 50%;
  overflow: hidden;
  background-image: url("../assets/bgq.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.perCenter
  .bigPar
  .rig
  .problems
  .problemUl
  .problemLi
  .problemDesc
  .problemDescDetail {
  margin-left: 10px;
}
.perCenter .bigPar .rig .problems .problemUl .problemLi .problemReply {
  text-align: left;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  width: 90%;
  margin-left: 40px;
}
.perCenter .bigPar .rig .problems .problemUl .problemLi .problemReply span {
  color: #666666 !important;
}
.perCenter .bigPar .rig .myAddress {
  width: 100%;
}
.perCenter .bigPar .rig .myAddress .myAddressTitle {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  font-size: 14px;
  line-height: 36px;
  border-bottom: 1px solid #ccc;
}
.perCenter .bigPar .rig .myAddress .addBtn {
  /* width: 10%; */
  padding: 0 8px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #158dd3;
  color: #fff;
  font-size: 14px;
  margin-left: 85%;
  margin-top: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  border-radius: 4px;
}
.perCenter .bigPar .rig .myAddress .addressUl {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
}
.perCenter .bigPar .rig .myAddress .addressUl .addressLi {
  width: 48%;
  position: relative;
  height: 200px;
  /* background-color: pink; */
  border: 1px solid #ccc;
  cursor: pointer;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 12px 20px 0px rgba(92, 92, 92, 0.1);
  margin-bottom: 20px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(220, 220, 220, 1);
  box-shadow: 0px 4px 6px 0px rgba(74, 74, 74, 0.1);
  border-radius: 6px;
}
.perCenter .bigPar .rig .myAddress .addressUl .addressLi .head {
  position: absolute;
  top: 8%;
  left: 3%;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  overflow: hidden;
}
.perCenter .bigPar .rig .myAddress .addressUl .addressLi .default {
  height: 60px;
  width: 60px;
  position: absolute;
  top: 0;
  right: 0;
}
.perCenter .bigPar .rig .myAddress .addressUl .addressLi .head img,
.perCenter .bigPar .rig .myAddress .addressUl .addressLi .default img {
  display: block;
  width: 100%;
  height: 100%;
}
.perCenter .bigPar .rig .myAddress .addressUl .addressLi .addressPerUl {
  width: 70%;
  margin: 0 auto;
}
.perCenter
  .bigPar
  .rig
  .myAddress
  .addressUl
  .addressLi
  .addressPerUl
  .addressPerUlName {
  width: 100%;
  text-align: left;
  font-size: 22px;
  margin-top: 3%;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  /* autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.perCenter
  .bigPar
  .rig
  .myAddress
  .addressUl
  .addressLi
  .addressPerUl
  .addressPerUlAddress,
.perCenter
  .bigPar
  .rig
  .myAddress
  .addressUl
  .addressLi
  .addressPerUl
  .addressPerUlPhone,
.perCenter
  .bigPar
  .rig
  .myAddress
  .addressUl
  .addressLi
  .addressPerUl
  .addressPerUlEmail {
  width: 100%;
  text-align: left;
  font-size: 14px;
  line-height: 30px;
}
.perCenter
  .bigPar
  .rig
  .myAddress
  .addressUl
  .addressLi
  .addressPerUl
  .addressPerUlAddress {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  /* autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.perCenter .bigPar .rig .myAddress .addressUl .addressLi .operateDiv {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 5%;
}
.perCenter .bigPar .rig .myAddress .addressUl .addressLi .operateDiv p {
  width: 50%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
}
.perCenter .bigPar .rig .myAddress .addressUl .addressLi .operateDiv .editBtn {
  color: #158dd3;
}
.perCenter
  .bigPar
  .rig
  .myAddress
  .addressUl
  .addressLi
  .operateDiv
  .deleteBtn {
  color: red;
}
.perCenter .bigPar .rig .addAddress {
  width: 100%;
  /* padding-top: 30px; */
}
.perCenter .bigPar .rig .addAddress .backP {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  font-size: 18px;
  line-height: 36px;
  border-bottom: 1px solid #ccc;
  position: relative;
  height: 50px;
}
.perCenter .bigPar .rig .addAddress .backP .back {
  position: absolute;
  left: 1%;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  line-height: 50px;
}
.perCenter .bigPar .rig .addAddress .backP .addTitle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 15px;
  line-height: 50px;
}
.perCenter .bigPar .rig .addAddress ul {
  width: 80%;
  margin: 0 auto;
  margin-top: 44px;
}
.perCenter .bigPar .rig .addAddress ul li {
  width: 100%;
  margin: 30px 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.perCenter .bigPar .rig .addAddress ul li .liP {
  width: 20%;
  /* background-color: blue; */
  text-align: right;
  height: 40px;
  line-height: 40px;
}
.perCenter .bigPar .rig .addAddress ul li input {
  width: 60%;
  /* background-color: red; */
  outline: none;
  border: 1px solid #ccc;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  padding-left: 4px;
  text-align: left;
  color: black;
  margin-left: 3%;
  border-radius: 6px;
}
.perCenter .bigPar .rig .addAddress .save {
  width: 20%;
  height: 36px;
  line-height: 36px;
  text-align: center;
  background-color: #158dd3;
  color: #fff !important;
  margin: 0 auto;
  margin-top: 30px;
  cursor: pointer;
  border-radius: 4px;
}
.perCenter .bigPar .rig .mySave {
  width: 100%;
}
.perCenter .bigPar .rig .mySave .storeUl {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 30px;
  flex-wrap: wrap;
}
.perCenter .bigPar .rig .mySave .storeUl .storeLi {
  width: 18%;
  min-height: 240px;
  /* background-color: pink; */
  margin-bottom: 20px;
  cursor: pointer;
  margin-right: 2%;
}
.perCenter .bigPar .rig .mySave .storeUl .storeLi .storeImg {
  border: 1px solid #f1f1f1;
  width: 100%;
  height: 74%;
  position: relative;
}
.perCenter .bigPar .rig .mySave .storeUl .storeLi .storeImg img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.perCenter .bigPar .rig .mySave .storeUl .storeLi .storeName {
  width: 100%;
  text-align: left;
  font-size: 14px;
  line-height: 20px;
  /* margin: 15px 0; */
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.perCenter .bigPar .rig .mySave .storeUl .storeLi .storePrice {
  width: 100%;
  text-align: left;
  font-size: 12px;
  color: red;
}
#noUseLi {
  opacity: 0;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #158dd3;
  color: #fff;
}
.el-pager li:hover {
  color: #158dd3;
  cursor: pointer;
}
.el-tabs__item.is-active {
  color: #158dd3 !important;
}
.perCenter .bigPar .rig .mySave .listInfo {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-top: 30px;
  padding-bottom: 3%;
}
.perCenter .bigPar .rig .mySave .listInfo li {
  display: inline-block;
  width: 23%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  cursor: pointer;
}
.perCenter .bigPar .rig .mySave .listInfo li .imgPar {
  width: 100%;
  height: 66%;
}
.perCenter .bigPar .rig .mySave .listInfo li p {
  margin-top: 2%;
}
.perCenter .bigPar .rig .mySave .listInfo li .imgPar img {
  display: block;
  width: 100%;
  height: 100%;
}
.perCenter .bigPar .rig .mySave .listInfo li .listInfoTime {
  text-align: left;
  /* padding-left: 20px; */
  font-size: 12px;
  color: #858383;
}
.perCenter .bigPar .rig .mySave .listInfo li .listInfoTitle {
  text-align: left;
  /* padding-left: 20px; */
  font-size: 15px;
  color: black;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 600;
}
.perCenter .bigPar .rig .mySave .listInfo li .listInfoDesc {
  /* 前几行均匀分布，最后一行左对齐 */
  text-align: justify;
  text-align-last: left;
  -moz-text-align-last: left;
  /* padding-left: 20px; */
  font-size: 12px;
  line-height: 26px;
  color: black;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

/* ----------------------- */
.perCenter .bigPar .rig .mySave .el-col-12 {
  width: 100%;
}
.perCenter .bigPar .rig .mySave .databaseContPart {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  margin: 0 auto;
  margin-top: 30px;
}
.perCenter .bigPar .rig .mySave .databaseContPart .tac {
  font-size: 18px;
  width: 18%;
}
.perCenter .bigPar .rig .mySave .databaseContPart .databaseCont {
  width: 80%;
  margin-left: 1%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
}
.perCenter
  .bigPar
  .rig
  .mySave
  .databaseContPart
  .databaseCont
  .databaseContModel {
  width: 47%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 211px;
  margin: 1% 0;
  cursor: pointer;
  /* background-color: pink; */
}
.perCenter
  .bigPar
  .rig
  .mySave
  .databaseContPart
  .databaseCont
  .databaseContModel
  .liLef {
  height: 100%;
  width: 50%;
  border-radius: 3px;
  overflow: hidden;
  margin-right: 1%;
}
.perCenter
  .bigPar
  .rig
  .mySave
  .databaseContPart
  .databaseCont
  .databaseContModel
  .liLef
  img {
  display: block;
  width: 100%;
  height: 100%;
}
.perCenter
  .bigPar
  .rig
  .mySave
  .databaseContPart
  .databaseCont
  .databaseContModel
  .liRig {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.perCenter
  .bigPar
  .rig
  .mySave
  .databaseContPart
  .databaseCont
  .databaseContModel
  .liRig
  .liRigTitle {
  font-size: 16px;
  color: black;
  font-weight: 600;
  width: 100%;
  text-align: left;
  margin: 6% 0;
}
.perCenter
  .bigPar
  .rig
  .mySave
  .databaseContPart
  .databaseCont
  .databaseContModel
  .liRig
  .liRigDesc {
  font-size: 14px;
  color: #868686;
  font-weight: 400;
  width: 100%;
  text-align: left;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.perCenter .bigPar .rig .mySave .databaseDetail {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.perCenter .bigPar .rig .mySave .databaseDetail .lef {
  width: 68%;
}
.perCenter .bigPar .rig .mySave .databaseDetail .lef .title {
  width: 100%;
  text-align: left;
  font-size: 26px;
  font-weight: 600;
  margin: 25px 0;
}
.perCenter .bigPar .rig .mySave .databaseDetail .lef .liPar {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  color: #828181;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 16px;
}
.perCenter .bigPar .rig .mySave .databaseDetail .lef .liPar li span {
  margin: 0 3px;
}
.perCenter .bigPar .rig .mySave .databaseDetail .lef .pdfPar {
  width: 100%;
  margin: 0 auto;
}
.perCenter .bigPar .rig .mySave .databaseDetail .rig {
  width: 30%;
  /* background-color: pink; */
  margin-left: 1%;
}
.perCenter .bigPar .rig .mySave .databaseDetail .rig .comment {
  width: 80%;
  font-size: 26px;
  font-weight: 600;
  text-align: left;
  margin: 28px auto;
}
.perCenter .bigPar .rig .mySave .databaseDetail .rig .commentPar {
  width: 80%;
  margin: 0 auto;
  margin-bottom: 20px;
}
.perCenter .bigPar .rig .mySave .databaseDetail .rig .commentPar .commentParLi {
  width: 100%;
  font-size: 12px;
  line-height: 26px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  text-align: left;
}
.perCenter
  .bigPar
  .rig
  .mySave
  .databaseDetail
  .rig
  .commentPar
  .commentParLi
  .commentName {
  width: 14%;
  text-overflow: ellipsis;
  overflow: hidden;
}
.perCenter
  .bigPar
  .rig
  .mySave
  .databaseDetail
  .rig
  .commentPar
  .commentParLi
  .commentCont {
  width: 50%;
  margin: 0 2px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.perCenter
  .bigPar
  .rig
  .mySave
  .databaseDetail
  .rig
  .commentPar
  .commentParLi
  .commentTime {
  width: 30%;
}
.perCenter .bigPar .rig .mySave .databaseDetail .rig .commentTextArea {
  width: 80%;
  margin: 0 auto;
  margin-top: 10px;
  line-height: 26px;
  font-size: 15px;
  padding: 3px;
}
.perCenter .bigPar .rig .mySave .databaseDetail .rig .submitBtn {
  width: 80%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  margin: 20px auto;
  color: #fff;
  font-size: 16px;
  background-color: #158dd3;
}
/* 图片上传 */
.avatar-uploader .el-upload {
  /* border: 1px dashed #d9d9d9; */
  /* border-radius: 6px; */
  cursor: pointer;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #158dd3;
}
.avatar-uploader-icon {
  font-size: 26px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* -------------- */
.perCenter .bigPar .rig .updatePerInfo {
  width: 100%;
  /* padding-left: 8%; */
}
.perCenter .bigPar .rig .updatePerInfo .updatePerInfoTitle {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  font-size: 15px;
  line-height: 36px;
  border-bottom: 1px solid #f1f1f1;
}
.perCenter .bigPar .rig .updatePerInfo .nowHeadImg {
  height: 100px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: 6%;
  margin-top: 30px;
}
.perCenter .bigPar .rig .updatePerInfo .nowHeadImg .nowHeadImgTitle {
  height: 100%;
  line-height: 100px;
  text-align: left;
  font-size: 16px;
}
.perCenter .bigPar .rig .updatePerInfo .nowHeadImg .headImgPar {
  height: 100px;
  width: 100px;
  cursor: pointer;
  position: relative;
}
.perCenter .bigPar .rig .updatePerInfo .nowHeadImg .headImgPar img {
  display: block;
  width: 100%;
  height: 100%;
}
.perCenter
  .bigPar
  .rig
  .updatePerInfo
  .nowHeadImg
  .headImgPar
  .avatar-uploader {
  /* background-color: pink; */
  position: absolute;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100px;
  height: 100px;
  /* opacity: 0; */
}
.perCenter
  .bigPar
  .rig
  .updatePerInfo
  .nowHeadImg
  .headImgPar
  .avatar-uploader
  .avatar-uploader-icon {
  width: 100px;
  height: 100px;
}
.perCenter .bigPar .rig .updatePerInfo .updateName,
.perCenter .bigPar .rig .updatePerInfo .updatePhone {
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin: 30px 0;
}
.perCenter .bigPar .rig .updatePerInfo .updateName {
  margin-left: 6%;
}
.perCenter .bigPar .rig .updatePerInfo .updateName .updateNameTitle,
.perCenter .bigPar .rig .updatePerInfo .updatePhone .updatePhoneTitle {
  height: 100%;
  line-height: 40px;
}
.perCenter .bigPar .rig .updatePerInfo .updateName input,
.perCenter .bigPar .rig .updatePerInfo .updatePhone input {
  width: 30%;
  height: 100%;
  line-height: 40px;
  padding-left: 5px;
  margin-left: 2%;
  border: 1px solid #ccc;
}
.perCenter .bigPar .rig .updatePerInfo .upDatePassWord {
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  /* margin: 0 auto; */
  line-height: 30px;
  margin-left: 6%;
  cursor: pointer;
}
.perCenter .bigPar .rig .updatePerInfo .upDatePassWord:hover {
  color: #158dd3;
}
.perCenter .bigPar .rig .updatePerInfo .upDatePassWord span {
  font-size: 16px;
}
.perCenter .bigPar .rig .updatePerInfo .updatePasswordPart {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: 6%;
}
.perCenter .bigPar .rig .updatePerInfo .updatePasswordPart .zh {
  width: 30%;
  outline: none;
  border: 1px solid #ccc;
  height: 40px;
  margin: 2% 0;
  border-radius: 4px;
}
.perCenter .bigPar .rig .updatePerInfo .updatePasswordPart .keyNum {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border-radius: 4px;
}
.perCenter .bigPar .rig .updatePerInfo .updatePasswordPart .keyNum input {
  width: 30%;
  height: 40px;
  outline: none;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.perCenter .bigPar .rig .updatePerInfo .updatePasswordPart .keyNum div {
  width: 13%;
  height: 40px;
  background-color: #158dd3;
  line-height: 40px;
  text-align: center;
  border: 1px solid #ccc;
  color: #fff;
  margin-left: 1%;
  cursor: pointer;
  border-radius: 3px;
}
input {
  padding-left: 10px;
}
.perCenter .bigPar .rig .updatePerInfo .updatePasswordPart .passwordInput,
.perCenter .bigPar .rig .updatePerInfo .updatePasswordPart .passwordInputAgin {
  width: 30%;
  height: 40px;
  outline: none;
  border: 1px solid #ccc;
  margin: 1% 0;
  border-radius: 4px;
}
.perCenter .bigPar .rig .updatePerInfo .saveAndSubmit {
  width: 15%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  margin: 50px auto;
  background-color: #158dd3;
  cursor: pointer;
  border-radius: 4px;
}
.actColor {
  border: 1px solid #158dd3 !important;
}
.grayCl {
  background-color: #cacaca !important;
  color: #fff !important;
  cursor: not-allowed !important;
}
.wuliuTop {
  width: 98%;
  margin: 0 auto;
  border-bottom: 1px solid #f1f1f1;
  /* background-color: pink; */
  /* position: relative; */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.wuliuTop .wuliuBack {
  width: 42%;
  text-align: left;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  /* background-color: green; */
  padding-left: 10px;
  /* position: absolute;
  left: 10px; */
  cursor: pointer;
}
.wuliuTop .wuliuTitle {
  width: 50%;
  text-align: left;
  font-size: 14px;
  /* background-color: #158dd3; */
  height: 30px;
  line-height: 30px;
  /* position: absolute;
  left: 50%;
  transform: translateX(-50%); */
}
.wuliuMid {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* background-color: yellow; */
  margin-top: 10px;
}
.wuliuMid .wuliuImg {
  height: 247px;
  width: 247px;
  margin-left: 30px;
}
.wuliuMid .wuliuImg img {
  display: block;
  width: 100%;
  height: 100%;
}
.wuliuMid .wuliuComp {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* background-color: rgb(105, 45, 105); */
  width: 66%;
  margin-left: 10px;
}
.wuliuMid .wuliuComp .wuliuUl {
  width: 100%;
  /* height: 40px; */
  /* line-height: 40px; */
  font-size: 14px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  /* background-color: yellow; */
}
.wuliuMid .wuliuComp .wuliuComponay {
  width: 100%;
  border: 1px solid #ccc;
  height: 40px;
  line-height: 40px;
  padding-left: 5px;
}
.wuliuMid .wuliuComp .wuliuId {
  width: 100%;
  border: 1px solid #ccc;
  height: 40px;
  line-height: 40px;
  padding-left: 5px;
}
/* <div class="wuliuComp">
              <ul class="wuliuUl">
                <li class="wuliuComponay">物流公司</li>
                <li class="wuliuId">物流单号</li>
              </ul>
              <ul class="wuliuUl">
                <li class="wuliuComponay">韵达速运</li>
                <li class="wuliuId">9999999999999999</li>
              </ul>
            </div> */
.wuliuTime {
  width: 25%;
  margin-left: 30px;
  /* margin: 0 auto; */
  /* background-color: #ccc; */
  margin-top: 30px;
}
.botNono {
  border-bottom: 0 !important;
  border-right: 0 !important;
}
.botNo {
  border-bottom: 0 !important;
}
/* <div style="margin-top: 15px;" class="isPjia" v-show="showModel==10">
          <div class="wuliuTop">
            <p class="wuliuBack">返回</p>
            <p class="wuliuTitle">物流信息</p>
          </div>
          <div class="wuliuMid">
            <div class="wuliuImg"><img src="../assets/3.png" alt=""></div>
            <div class="wuliuComp">
              <p class="wuliuComponay">韵达速运</p>
              <p class="wuliuId">9999999999999999</p>
            </div>
          </div>
          <div class="wuliuTime">
              <div class="block">
                  <el-timeline>
                    <el-timeline-item
                      v-for="(activity, index) in activities2"
                      :key="index"
                      :icon="activity.icon"
                      :type="activity.type"
                      :color="activity.color"
                      :size="activity.size"
                      :timestamp="activity.timestamp">
                      {{activity.content}}
                    </el-timeline-item>
                  </el-timeline>
                </div>
          </div> */
.lefUl {
  width: 30% !important;
  font-weight: 600 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/perCenter.vue